import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Empty, message, Modal, Skeleton, Space, TablePaginationConfig, Tooltip } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import { FireBaseNotificationModel } from 'features/notification/components/modal/firebaseNotificationModel';
import { SendFirebaseNotificationModal } from 'features/notification/components/modal/SendFirebaseNotificationModal';
import { NotificationCustomerFilterFormValuesPaginated } from 'features/notification/components/type';
import { useDeleteSelectedCustomers } from 'features/notification/use-cases/delete-selected-customers';
import { useMoveSelectedUserList } from 'features/notification/use-cases/move-selected-cutomer';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationCustomerList } from 'types/notification-type';
import { NotificationModelSelected } from '../modal/NotificationModelSelected';
import { useUserContext } from 'features/users';
type NotificationTableProps = {
    isUsersListLoading: boolean;
    typeReportList: NotificationCustomerList[];
    itemsCount: number;
    tableParams: NotificationCustomerFilterFormValuesPaginated;
    refetch: any;
    updateParams: Dispatch<SetStateAction<NotificationCustomerFilterFormValuesPaginated>>;
    tabKey: number;
    selectedRowKeys: React.Key[];
    setSelectedRowKeys: Dispatch<SetStateAction<React.Key[]>>;
    uniqueDeviceCount: number;
};

export const NotificationListCustomerTable = ({
    typeReportList,
    isUsersListLoading,
    itemsCount,
    tableParams,
    refetch,
    updateParams,
    tabKey,
    selectedRowKeys,
    setSelectedRowKeys,
    uniqueDeviceCount
}: NotificationTableProps) => {
    const { t } = useTranslation();
    const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false);
    const [showfireBaseNotification, setShowFireBaseNotification] = useState<boolean>(false);
    const [openNotificationModel, setOpenNotificationModel] = useState<boolean>(false);
    const [selectedCount, setSelectedCount] = useState(0);
    const [allUser, setAllUser] = useState('')
    const {user}=useUserContext();
    const [Data, setData] = useState<any[]>([]);
    const { confirm } = Modal;
    const getSessionId = () => {
        const id = localStorage.getItem("sessionId");

        if (!id) {
            localStorage.setItem("sessionId", user?.id as any);
        }

        return id;
    };
    const sessionId = getSessionId();
    const totalRows = typeReportList?.length;

    const selectedKeySet = new Set(selectedRowKeys.map((key) => String(key)));

    const selectedDeviceIds = (typeReportList ?? [])
        .filter((item) =>
            selectedKeySet.has(
                String(item.ParticipantId === 0 ? item.UserId : item.ParticipantId)
            )
        )
        .map((item) => (item.DeviceId || '').trim())
        .filter(Boolean);

    // how many different devices the selected rows belong to
    const selectedDeviceCount = new Set(selectedDeviceIds).size;

    const isAllSelected =
        selectedRowKeys.length > 0 && selectedRowKeys.length === totalRows;

    // nothing selected -> dataset-wide count from the API,
    // any selection (including select-all) -> unique devices among the selected rows
    const uniqueContactCount =
        selectedRowKeys.length > 0 ? selectedDeviceCount : uniqueDeviceCount || 0;
    const disableFirebaseButton =
        selectedRowKeys.length > 0 && !isAllSelected;
    const { mutate } = useMoveSelectedUserList();
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<NotificationCustomerList> | SorterResult<NotificationCustomerList>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    const handleOpenModal = () => {
        const selectedUsersData = getSelectedUsers();
        if (!selectedUsersData.length) {
            setShowFireBaseNotification(true)
        } else {
            setShowAddItemModal(true)
        }
        document.body.style.overflow = 'hidden';
    }

    const { mutate: mutateDeleteCustomer } =
        useDeleteSelectedCustomers();
    const handleDelete = async (record: any) => {
        const selectedUsers = getSelectedUsers();
        try {
            const payload = {
                SessionId: sessionId,
                // ParticipatnIds: selectedUsers.map((user) => ({
                //     ParticipantId: user.ParticipantId,
                //     UserId: user.UserId
                // }))
                ParticipatnIds: [{
                    ParticipantId: record.ParticipantId,
                    UserId: record.UserId
                }]
            };




            mutateDeleteCustomer(payload);

            setSelectedRowKeys([]);

            const participantIds = selectedUsers.map(user1 => user1.ParticipantId);

            const newData = Data.filter(
                (item: any) => !participantIds.includes(item.ParticipantId)
            );

            setData(newData);

        } catch (error: any) {
            message.error(error?.message || "Something went wrong");
        }
    };
    const handleAllDelete = async () => {
        const selectedUsers = getSelectedUsers();
        try {
            const payload = {
                SessionId: sessionId,
                ParticipatnIds: selectedUsers.map((user2) => ({
                    ParticipantId: user2.ParticipantId,
                    UserId: user2.UserId
                })),
            };
            mutateDeleteCustomer(payload);
            setSelectedRowKeys([]);
            const participantIds = selectedUsers.map(user3 => user3.ParticipantId);
            const newData = Data.filter(
                (item: any) => !participantIds.includes(item.ParticipantId)
            );

            setData(newData);

        } catch (error: any) {
            message.error(error?.message || "Something went wrong");
        }
    };
    const handleRemoveDelete = async () => {
        const selectedUsers = getSelectedUsers();
        try {
            const payload = {
                SessionId: sessionId,
                // ParticipatnIds: selectedUsers.map(() => ({
                //     ParticipantId: 0,
                //     UserId: 0
                // })),
                ParticipatnIds: [{
                    ParticipantId: 0,
                    UserId: 0
                }],
                flag: "all"
            };

            mutateDeleteCustomer(payload);

            setSelectedRowKeys([]);

            const participantIds = selectedUsers.map(user4 => user4.ParticipantId);

            const newData = Data.filter(
                (item: any) => !participantIds.includes(item.ParticipantId)
            );

            setData(newData);

        } catch (error) {
            console.error("error");
        }
    };
    const showDeleteConfirm = (record: any) => {
        confirm({
            title: 'Are you sure you want to delete selected customers?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDelete(record);
            },
        } as any);
    };
    const onChangeRemoveAll = () => {
        confirm({
            title: 'Are you sure you want to remove All  customers?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleRemoveDelete();
            },
        } as any);
    };
    const handleCloseModal = () => {
        setShowAddItemModal(false)
        document.body.style.overflow = 'visible';
    }

    const rowSelection = {
        selectedRowKeys,
        preserveSelectedRowKeys: false,

        onChange: (
            keys: React.Key[],
            selectedRows: NotificationCustomerList[]
        ) => {
            setSelectedRowKeys(keys);
            setSelectedCount(selectedRows.length);
        },

        onSelectAll: (
            selected: boolean,
        ) => {

            if (selected) {
                const keys = typeReportList.map((item) =>
                    item.ParticipantId === 0 ? item.UserId : item.ParticipantId
                );

                setSelectedRowKeys(keys);
                setSelectedCount(keys.length);
                if (tabKey === 1) {
                    setOpenNotificationModel(true);
                }
            } else {
                setSelectedRowKeys([]);
                setSelectedCount(0);
                setOpenNotificationModel(false);
            }
        },
    };

    const getSelectedUsers = () => {

        return typeReportList?.filter(item =>
            selectedRowKeys.includes(item.ParticipantId)
        );
    };
    const handleMoveToSelected = async () => {
        const selectedUsers = getSelectedUsers();
        if (!selectedRowKeys || selectedRowKeys.length === 0) {
            message.error("Please select at least one user");

            return;
        }

        const payload = {
            UserDataList: selectedUsers,
            SessionId: sessionId
        };

        mutate(payload, {});
        setSelectedRowKeys([]);
    };

    return (
        <StyledTableWrapper>

            <div className={`cstmrightmdl ${showAddItemModal && "show"}`}>
                <SendFirebaseNotificationModal onClose={handleCloseModal}
                    allUser={allUser} showAddItemModal={showAddItemModal}
                    setSelectedRowKeys={setSelectedRowKeys} refetch={refetch}
                    sessionId={sessionId as any} />
            </div>

            <StyledTableHeader>
                <Space>
                    <RecordCountBadge
                        text={t('vendingMachine.foundRecord')}
                        count={isUsersListLoading ? 0 : itemsCount || 0}
                    />
                    <RecordCountBadge
                        text='Unique Record'
                        count={isUsersListLoading ? 0 : uniqueContactCount}
                    />
                </Space>

                {/* Right side: Buttons */}
                <Space>
                    {tabKey && tabKey == 1 ? (
                        <Button type="primary" onClick={handleMoveToSelected}>  Move to Selected  </Button>
                    ) : (
                        <>

                            <Button type="primary" disabled={disableFirebaseButton}
                                style={
                                    disableFirebaseButton
                                        ? {
                                            background: "#000000",
                                            borderColor: "#020305",
                                            color: "#fff",
                                            opacity: 1,
                                            cursor: "not-allowed",
                                        }
                                        : {}
                                }
                                onClick={() => handleOpenModal()}> Send Firebase Notification  </Button>

                            {/* <Button danger onClick={showDeleteConfirm} >   Remove </Button> */}
                            <Button danger onClick={onChangeRemoveAll} >   Remove All </Button>
                            {/* <Button danger onClick={handleAllDelete} >   Remove  </Button> */}
                            {selectedRowKeys.length > 1 && (
                                <Button danger onClick={handleAllDelete}>
                                    Remove
                                </Button>
                            )}
                        </>
                    )}



                </Space>

            </StyledTableHeader>
            <Table<NotificationCustomerList>
                // loading={isUsersListLoading}
                // dataSource={typeReportList}
                className="cstltblwthldr"
                rowSelection={rowSelection}
                locale={{
                    emptyText: isUsersListLoading ? <Skeleton active={true} /> : <Empty />
                }}
                loading={isUsersListLoading && { indicator: <div><TableLoader /></div> }}
                dataSource={isUsersListLoading ? [] : typeReportList}
                //rowKey="ParticipantId"
                // rowKey="ParticipantId"
                rowKey={(record) =>
                    record.ParticipantId == 0 ? record.UserId : record.ParticipantId
                }
                onChange={handleTableChange}
                pagination={{
                    current: tableParams.page,
                    defaultPageSize: tableParams.size,
                    total: itemsCount,
                }}
            >
                <Column<NotificationCustomerList>
                    title={'Customer Name '}
                    render={(_, record) =>
                        `${record?.FirstName || ""} ${record.LastName || ""}`.trim()
                    }
                />
                <Column<NotificationCustomerList>
                    title={'Gender '}
                    dataIndex={'Gender'}
                />
                <Column<NotificationCustomerList>
                    title={'Email Id '}
                    dataIndex={'Email'}
                />
                <Column<NotificationCustomerList>
                    title={' Mobile Number '}
                    dataIndex={'MobileNo'}
                />
                <Column<NotificationCustomerList>
                    title={'Nationality '}
                    dataIndex={'Nationality'}
                />
                <Column<NotificationCustomerList>
                    title="Event Name"
                    dataIndex="EventName"
                    render={(eventName: string) => {
                        const maxLength = 30;

                        if (!eventName) {
                            return "-";
                        }

                        if (eventName.length > maxLength) {
                            return (
                                <Tooltip title={eventName}>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            maxWidth: 250,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            cursor: "pointer",
                                        }}
                                    >
                                        {eventName}
                                    </span>
                                </Tooltip>
                            );
                        }

                        return eventName;
                    }}

                />
                {tabKey === 2 && (
                    <Column<NotificationCustomerList>
                        title="Action"
                        key="action"
                        width={120}
                        render={(_, record) => (
                            <Button
                                danger
                                size="small"
                                onClick={() => showDeleteConfirm(record)}
                            >
                                Remove
                            </Button>
                        )}
                    />
                )}

            </Table>
            {showfireBaseNotification && <FireBaseNotificationModel setShowAddItemModal={setShowAddItemModal} selectedRowKeys={selectedRowKeys} showfireBaseNotification={showfireBaseNotification} setAllUser={setAllUser} setShowFireBaseNotification={setShowFireBaseNotification} />}
            {openNotificationModel && (
                <NotificationModelSelected
                    open={openNotificationModel}
                    actionType="Approve"
                    selectedCount={selectedCount}
                    totalCount={itemsCount}
                    onConfirm={() => {
                        setOpenNotificationModel(false);
                    }}
                    onCancel={() => {
                        setOpenNotificationModel(false);
                    }}
                    updateParams={updateParams}
                    tableParams={tableParams}
                    setSelectedRowKeys={setSelectedRowKeys}
                />
            )}
        </StyledTableWrapper>
    );
};
